export const profileData = [
    {
        id: "intro",
        title: "About Me",
        subtitle: "Based in Belgium 🇧🇪",
        content: `Passionate about creating impact and driven by curiosity and adaptability, I combine business insight and data skills to solve complex problems, collaborate effectively with diverse teams, and turn ideas into practical solutions.`,
    },
    {
        id: "journey",
        title: "🌱 My Journey",
        content: `Having lived in 9 countries (Thailand 🇹🇭, Switzerland 🇨🇭, the UK 🇬🇧, Denmark 🇩🇰, Slovenia 🇸🇮, Spain 🇪🇸, the Maldives 🇲🇻, Malaysia 🇲🇾, and Belgium 🇧🇪), adapting quickly and working across cultures has shaped how I learn and grow. Along the way, I’ve learned Dutch, become a mom, and stayed endlessly curious.`,
    },
    {
        id: "accomplishment",
        title: "🎯 Accomplishment",
        content: `🏆 Winner of the 2024 Tech 4 Positive Futures Challenge by Capgemini Belgium — created innovative tech solutions tackling climate change impacts with creativity and practical execution.`,
    },
    {
        id: "skills",
        title: "💼 What I Do",
        content: `I focus on learning by doing — building web applications, analyzing datasets for insights, and improving my skills through real-world challenges and client collaborations. Currently exploring the Data Engineering field.`
    },
    {
        id: "beyond",
        title: "🌟 Beyond the Code",
        content: (<ul>
            <li>🌍 Learn new languages</li>
            <li>✈️ Travel & explore local (spicy!) cuisine</li>
            <li>📚 Get totally absorbed in novels — fiction is my go-to way to escape reality (and avoid chores)</li>
            <li>💡 Figure out how tech can help save the planet — because we do care, right?</li>
        </ul>),
    },
];
